export default __webpack_public_path__ + "static/media/FLT.27b81303.png";